export default __webpack_public_path__ + "static/media/notThere.73538bc9.png";